import React from "react";
import { Button } from "../Button";
import { Content } from "./styles";

interface Props {
  title: string;
  description?: string;
  confirm: ()=> void;
}
export function ModalInfo({ title,description, confirm,...rest }: Props) {
  return(
    <Content
        visible={true}
        onCancel={confirm}
        closable={false}
        footer={[
          <div className="actions">
          <Button title="Fechar" onClick={confirm} />
          </div>
          
        ]}
        width="500px"
        maskStyle={{
          background: 'rgba(43, 43, 69, 0.8)'
        }}
      >
        <div className="title">
          {title}
        </div>
        <div className="description">
          {description}
        </div>
      </Content>
      
  )
}
